import type { HttpInterceptorFn } from '@angular/common/http';
import { selfServiceBaseUrl } from '../self-service-base-url';

/** A platform URL on a developer's machine: http://localhost:8090/spriced/platform/… */
const LOCAL_PLATFORM = /^https?:\/\/(?:localhost|127\.0\.0\.1)(?::\d+)?\/spriced\/platform(?=[/?#]|$)/i;

/**
 * Builders save some API URLs in full (a nested table's `levelApiUrl`, a table's
 * `computeUrl`, a table view's `apiUrl`, …). A dashboard built on a dev machine
 * therefore carries "http://localhost:8090/spriced/platform/…", and the deployed
 * app would call localhost in the viewer's browser. Such a request is sent to this
 * deployment's platform API instead. Nothing changes when the app itself runs
 * against localhost, and URLs of any other host are left alone.
 */
export const savedLocalhostUrlInterceptor: HttpInterceptorFn = (req, next) => {
  if (!LOCAL_PLATFORM.test(req.url)) return next(req);
  const base = selfServiceBaseUrl().replace(/\/+$/, '');
  if (!/^https?:\/\//i.test(base) || LOCAL_PLATFORM.test(base)) return next(req);
  return next(req.clone({ url: req.url.replace(LOCAL_PLATFORM, base) }));
};
